import axios from 'axios';
import endpoints from '../define/endpoints';

export async function useStoreCart(token, user_id, cart) {
    const LAST_STORED_CART = 'last_stored_cart';

    const cartData = {
        selected_language_id: cart.selectedLanguageId,
        availability_id: cart.availabilityId,
        participants: cart.participants,
        listing_id: cart.listingId,
        product_id: cart.productIdx,
        type: cart.type,
        total: cart.total,
        user_id: user_id,
        user_locale: window.freedomeConfig.locale,
        wc_cart_hash: btoa(
            JSON.stringify
                ({
                    type: cart.type,
                    listing_id: cart.listingId,
                    product_id: cart.productIdx,
                    voucher_option_id: cart.voucherOptionId !== null ? cart.voucherOptionId.toString() : null,
                    selected_language_id: cart.selectedLanguageId,
                    availability_id: cart.availabilityId,
                    top1_quantity: cart.participants.top1?.quantity ?? cart.participants.quantity,
                    top2_quantity: cart.participants.top2?.quantity ?? null,
                    id_wordpress: cart.wordpressProductId
                }))
    };

    const stringifiedCartData = JSON.stringify(cartData);

    if (localStorage.getItem(LAST_STORED_CART) === stringifiedCartData) {
        return false; // the cart is already stored
    }

    const response = await axios({
        method: 'post',
        url: `${endpoints.core}/carts/store`,
        data: cartData,
        headers: { Authorization: `Bearer ${token}` },
    });

    if(response.status !== 200) {
        return false;
    }

    localStorage.setItem(LAST_STORED_CART, stringifiedCartData);
    localStorage.setItem('cart_id', response.data);

    return response.data;
}
